if (typeof AnnouncementMarquee !== 'function') {
  class AnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;

      this.track = this.querySelector('[data-marquee-track]');
      this.source = this.querySelector('[data-marquee-source]');

      if (!this.track || !this.source) return;

      this.isInitialized = true;
      this.speed = Math.max(Number.parseInt(this.dataset.speed, 10) || 80, 1);
      this.direction = this.dataset.direction === 'right' ? 'right' : 'left';

      this.refresh = this.refresh.bind(this);
      this.scheduleRefresh = this.scheduleRefresh.bind(this);

      this.resizeObserver = new ResizeObserver(this.scheduleRefresh);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.source);

      this.intersectionObserver = new IntersectionObserver((entries) => {
        this.classList.toggle('announcement-bar__marquee--paused', !entries[0].isIntersecting);
      });
      this.intersectionObserver.observe(this);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.scheduleRefresh);
      }

      this.scheduleRefresh();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      window.cancelAnimationFrame(this.refreshFrame);
      this.isInitialized = false;
    }

    scheduleRefresh() {
      window.cancelAnimationFrame(this.refreshFrame);
      this.refreshFrame = window.requestAnimationFrame(this.refresh);
    }

    refresh() {
      this.track.querySelectorAll('[data-marquee-clone]').forEach((clone) => clone.remove());

      const sequenceWidth = this.source.getBoundingClientRect().width;
      if (sequenceWidth === 0) return;

      const cloneCount = Math.max(Math.ceil(this.clientWidth / sequenceWidth), 1);

      for (let index = 0; index < cloneCount; index += 1) {
        const clone = this.source.cloneNode(true);
        clone.removeAttribute('data-marquee-source');
        clone.setAttribute('data-marquee-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
          element.removeAttribute('data-shopify-editor-block');
        });
        this.track.appendChild(clone);
      }

      this.style.setProperty('--announcement-marquee-distance', `${sequenceWidth}px`);
      this.style.setProperty('--announcement-marquee-duration', `${sequenceWidth / this.speed}s`);
      this.dataset.direction = this.direction;
      this.classList.add('announcement-bar__marquee--ready');
    }
  }

  if (typeof customElements.get('announcement-marquee') === 'undefined') {
    customElements.define('announcement-marquee', AnnouncementMarquee);
  }
}
